<template>
  <div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
    <!-- <admin-sidebar-menu v-if="admin" /> -->
    <div class="content-wrapper">
      <div class="container-wrapper center">
        <div>
            <i class="fa fa-chevron-left modal-goback" @click="goToLocationWindow"></i>
          <h3 class="d-inline heading">{{ pageTitle }}</h3>
        </div>
        <div class="heading-seperator"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-if="loading === false">
          <div class="row mt-2">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"> 
              <div class="row">
                <div class="col-12 col-sm-8 col-md-9 col-lg-10 col-xl-10">
                  <div class="mentee_name">{{ userTypeName }}: {{ menteeName }}
                    <div class="custom_hr"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-sm-8 col-md-9 col-lg-10 col-xl-10">
                  <div v-if="tasklists.length > 0">
                    <b-form-select v-model="tasklistId" :options="tasklists" style="margin-bottom: 0px !important" class="mb-3 col-md-12" @change="showAssessmentofTasklist()" />
                  </div>
                </div>
                <div class="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-2">
                  <div v-if="tasklists.length > 0">
                  <button class="btn btn-primary btn-sm task-goal-btn" @click="redirectTaskList">Task List</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tasklists.length > 0">
            <div v-show="tasklists_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
            <div class="col-md-12 counter_subtask-list p-0" id="tasks">
              <flash-message autoHide variant="success"></flash-message>
                <div class="col-md-12 override-padding counter_heading-list" v-if="goals_result.length == 0">
                  <div class="card">
                    <div class="card-body">
                      <div class="no-goal-text">No Task Goals Set!</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 override-padding counter_heading-list" v-else>
                    <div v-for = "(item, gindex) in goals_result" :key="gindex">
                        <b-link v-b-toggle="'collapse-' + item.sno" size="sm" :class="'sub-heading ' + item.goalStatus+'_section'" @click="getFontIcon(item.sno)">
                            <div class="d-flex bd-highlight">
                              <div class="flex-grow-1 bd-highlight goal_task_left">Tasks Due {{ item.completionDate }}</div>
                              <div class="bd-highlight">
                                <button v-if="item.goalStatus != 'completed'" :class="'goal-indicator-btn ' + getBtnColor(item.goalStatus)">{{ getNoOfDays(item.noOfDays, item.goalStatus)}} </button>
                                <button v-if="item.goalStatus == 'completed'" :class="'goal-indicator-btn ' + getBtnColor(item.goalStatus)"><i class="fa fa-check completed_tick"></i></button>
                              </div>
                              <div class="bd-highlight goal_task_right">
                                <i class="fa fa-angle-down togIcon" :id="'angle-'+ item.sno" aria-hidden="true"></i>
                              </div>
                            </div>
                        </b-link>
                        <b-collapse v-bind:id="'collapse-' + item.sno" class="task-wrapper goallist">
                            <div class="col-md-12 override-padding counter_task-list">
                              <MenteeGoalTaskList
                                :itemLength="item.tasks.length" 
                                :allItems="item.tasks"
                                :userId="userId"
                                :tasklistId="tasklistId"
                                subTaskId=""
                                headingId=""
                                :progress="item.progress">
                            </MenteeGoalTaskList>
                            <div style="clear: both;"></div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
                <div class="col-md-12 override-padding counter_task-list task-wrapper">
                    
                </div>
                <div style="clear: both;"></div>
            </div>
          </div>
          <div v-else class="noitems-custom-msg">No tasklist assigned for this mentee</div>
        </div>
      <EnterpriseAdminOverlaySidebar
              :isModalVisible="isModalVisible" 
              @close="closeSidebar"
              ref="location_sidebar" 
              readOnly="0" 
             />
    </div>
  </div>
  </div>
</div>
</template>

<script>
import router from '../../router/index';
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import custommodal from '../manager/custom_modal.vue';
import axios from 'axios';
import moment from 'moment';
import { store } from '../../store/store.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import MenteeGoalTaskList from '../enterpriseadmin/mentee_goal_task_list.vue';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

export default {
  data: function () {
    return {
      goals_result: [],
      isModalVisible: false,
      'history_title': '',
      'history_comment': '',
       loading: false,
       tasklists: [],
       tasklistId: '',
       userId: '',
       subTaskId: '',
       menteeName: '',
      'assessment_loading': false,
      tasklists_loading: false,
      repCount: 0,
      isReviewRepsModalVisible: false,
      isManager: false,
      pageTitle: '',
      program: '',
      userType: '',
      userTypeName: '',
      isModalVisible: false,
    }
  },
  methods: {
  showAssessmentofTasklist() {
     this.tasklists_loading = true;
     this.goals_result = [];
     axios.get('/enterpriseadmin/mentee-subtask-goals/' + this.userId + '/' + this.tasklistId)
      .then(response =>  {
          this.tasklists_loading = false;
          this.goals_result = response.data.goals;
          // console.log(this.goals_result)
          // this.subtasks = response.data.subtasks;
          const mentee = response.data.mentee;
      })
      .catch(function(error) {

      });
  },
  menteeRepititionApproval() {
    this.isReviewRepsModalVisible = true;
    const vmessage = 'hide_vmessage';
    this.$refs.review_reps_form.getScoreLists(vmessage);
  },
  getFontIcon(id) {
    if (document.getElementById('collapse-' + id).style.display == "") {
      document.getElementById('angle-'+ id).className = "fa fa-angle-down";
    } else {
      document.getElementById('angle-'+ id).className = "fa fa-angle-up";
    }
  },
    getBtnColor(statusName) {
        if (statusName == "overdue") {
            return "redBtn";
        } else if (statusName == "yellow") {
            return "yellowBtn";
        } else if (statusName == "green") {
            return "greenBtn";
        } else {
            return "greenBtn";
        }
    },
    getNoOfDays(count, statusName) {
        if (statusName == "overdue") {
            return "Overdue";
        } else if (statusName == "completed") {
            return "";
        } else {
            return (count > 1) ? count + ' Days' : count + " Day";
        }
    },
    redirectTaskList() {
      router.push('/enterprise-admin/mentees-task/' + this.accountId + '/' + this.userId + '?e4=' + this.tasklistId);
    },
    IsUserManager() {
      var roles = this.$store.state.roles;
      if(roles.indexOf('ROLE_ADMIN') > -1)
      {
        return true;
      }
      else {
        return false;
      }
    },
    goToLocationWindow() {
        this.isModalVisible = true;
        this.$refs.location_sidebar.accountId = this.accountId;
        this.$refs.location_sidebar.selectedComponent = 'UsersTab';
        this.$refs.location_sidebar.getLocationDetail(this.accountId);
    },
    closeSidebar() {
        this.isModalVisible = false;
    },
  },
  components: {
    UserMenu,
    GoBack,
    custommodal,
    AdminSidebarMenu,
    MenteeGoalTaskList,
    EnterpriseAdminSidebarMenu,
    EnterpriseAdminOverlaySidebar,
  },
  created: function () {
    this.isManager = this.IsUserManager();
    this.loading = true;
    this.accountId = this.$route.params.account_id;
    this.userId = this.$route.params.user_id;
    axios.get('/enterprise-admin/mentees_tasklists', {
      params: {
        user_id: this.userId,
        account_id: this.accountId,
      }
    })
    .then(response =>  {
      this.loading = false;
      var tasklistArr = response.data;
      this.tasklistId = tasklistArr[0]['id'];
      for( var i=0; i< tasklistArr.length; i++) {
        var tasklistOption = {value:tasklistArr[i]['id'], text:tasklistArr[i]['name']};
        this.tasklists.push(tasklistOption);
      }

      var e4_val = this.$route.query.e4;
      if(typeof(e4_val) !==  "undefined") {
          this.tasklistId = e4_val;
      }
      this.showAssessmentofTasklist();

    })
    .catch(function(error) {

    });

    axios('/enterprise-admin/user-account-info/'+this.userId+'/'+this.accountId,
    {
      method: 'GET',
    })
    .then(response => {
      this.program = response.data.program;
      this.menteeName = response.data.user_name;
      this.userType = response.data.user_type;
      
      if (this.userType == "apprentice") {
        this.pageTitle = "Apprentice Assessment";
        this.userTypeName = "Apprentice";
      } else {
        this.pageTitle = "Mentee's Assessment";
        this.userTypeName = "Mentee";
      }
    })
    .catch(() => {
    });

    var roles = store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }
  },

  updated() {
   setTimeout(()=>{
    var e1_val = this.$route.query.e1;
    var e2_val = this.$route.query.e2;
    var e3_val = this.$route.query.e3;
    if(e1_val) {
      var ele = document.getElementById("collapse-" + e1_val);
      ele.style.display = 'block';
      var ele2 = ele.parentElement.getElementsByClassName("panel-title")[0].getElementsByTagName("a")[0];
      ele2.className = '';
      var ele1 = document.getElementById("collapse-" + e1_val + "-" + e2_val);
      ele1.style.display = 'block';
      document.getElementById(e3_val).scrollIntoView(false);
    }
   }, 300);
  },

}
</script>

<style scoped>
.back-btn-wrapper {
  width:100%;
  margin-left: 10px;
  margin-right: 0px;
}
.mentee_name {
  font-size: 19px;
  margin-bottom: 0px;
}
hr {
  margin: 10px auto;
}
.custom_hr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin: 10px 0px;
  width: 100%;
}
.goReview{
  background-color: #FFF;
  border: 1px solid #00acee;
  border-radius: 10px;
  padding: 5px;
  line-height: 15px;
  margin: 20px 10px;
  float: right;
}
.goReview div {
  margin-left: 10px;
  float: left;
}
.review_count { 
  color: #00acee; 
  font-size: 24px; 
  margin-top: 6px; 
}
.review_text { 
  font-weight: 100;
  color: #7d7d7d;
}
.goRepsBtn, .goRepsBtn:active {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
}
.goRepsGrayBtn, .goRepsGrayBtn:active {
  color: #FFF; 
  background-color: #7d7d7d !important;
  border: 1px solid #7d7d7d !important;
  border-radius: 10px;
}
.manageBtn, .manageBtn:active, .manageBtn:focus {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 10px;
  width: 120px;
  margin-left: 10px;
}
.task-goal-btn {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-size: 13px;
  font-weight: 900;
  padding: 8px;
  width: 100%;
}
.sub-heading {
    padding: 10px;
    font-weight: 900;
    margin-bottom: 10px;
}
#tasks {
    padding: 0px;
}
.goal-indicator-btn {
    border-radius: 10px;
    font-size: 13px;
    padding: 5px;
    line-height: 12px;
    height: auto;
    width: 100px;
    text-align: center;
    outline: none !important;
}
.greenBtn, .greenBtn:active, .greenBtn:focus{
    color: #FFFFFF !important;
    background-color: #68C47E !important;
    border: 1px solid #68C47E !important;
}
.redBtn, .redBtn:active, .redBtn:focus {
    color: #FFFFFF !important;
    background-color: #FF0000 !important;
    border: 1px solid #FF0000 !important;
}
.yellowBtn, .yellowBtn:active, .yellowBtn:focus {
    color: #FFFFFF !important;
    background-color: #CBD538 !important;
    border: 1px solid #CBD538 !important;
}
.completed_tick {
  float: none !important;
  font-size: 18px !important;
}
.completed_section {
  background-color: #68C47E !important;
}
.goallist { 
  margin-top: -10px; 
}
.flex-grow-1 { padding-top: 5px; }
.no-goal-text {
  font-weight: 900;
  color: #7d7d7d;
  padding: 20px;
  vertical-align: middle;
  text-align: center;
}
@media (min-width: 992px) {
  .goal-indicator-btn { margin-right:  200px;}
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 576px) { 
  .goReview {
    float: left;
    margin-left: 0px !important;
  }
}
/* Iphone 5 */
@media (min-width: 320px) and (max-width: 576px) { 
  .manageBtn {
    width: 60px;
  }
  .mentee_name { font-size: 17px; }
}
@media (min-width: 375px) and (max-width: 601px) { 
  .manageBtn {
    width: 98px;
  }
}
/* Ipad */
@media (min-width: 768px) and (max-width: 1024px) { 
  .manageBtn {
    width: 76px;
  }
}
/* Large Devices */
@media (min-width: 809px) and (max-width: 1024px) { 
  .goal_task_left { margin-left: 1.5rem; }
  .goal_task_right { margin-right: 1.5rem; }
}
/* Extra Large Devices */
@media (min-width: 1200px) {
  .goal_task_left { margin-left: 1.5rem; }
  .goal_task_right { margin-right: 1.5rem; }
}
.modal-goback { font-size: 22px; margin: 5px 10px 0 0; cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/mentees_task_goal.vue